import { CalendarCheck, LogIn } from "lucide-react";
import { Link } from "react-router-dom";

export function FinalCtaSection({ onNavigate }) {
  return (
    <section className="landing-final-band" data-testid="landing-final">
      <div className="landing-final-inner landing-reveal">
        <p className="landing-module-num is-dark">SEI MODULI <i /> UNA SOLA PRECISIONE</p>
        <h2>Vediamo la tua officina<br />dentro ToolsValue</h2>
        <p className="landing-desc">
          Venti minuti, i tuoi codici, le tue commesse. Ti mostriamo dove finiscono i tuoi utensili e come
          diventa il costo di un pezzo. Alla fine sai se ti serve o no.
        </p>
        <div className="landing-final-actions">
          <a className="landing-login-btn is-large" href="#demo" data-testid="landing-cta-demo">
            <CalendarCheck size={17} />Prenota una demo di 20 minuti
          </a>
          <Link
            className="landing-outline-btn is-dark"
            to="/registra-azienda"
            onClick={onNavigate("/registra-azienda")}
            data-testid="landing-cta-register"
          >
            Crea il tuo account gratuito
          </Link>
          <Link
            className="landing-inline-link is-dark"
            to="/login"
            onClick={onNavigate("/login")}
            data-testid="landing-cta-login"
          >
            <LogIn size={14} /> Accedi
          </Link>
        </div>
      </div>
    </section>
  );
}
